<template lang="pug">
v-card
    v-snackbar(
        v-model="snackbar"
        :timeout="10000"
        color='error'
    ) {{ snackbarMessage }}   
    v-toolbar(dark dense color="red" class="navFixed" width="100%")
        v-toolbar-title i-Permit Preview
        v-spacer
        v-toolbar-title(v-if="ip.ipPengesahan && ip.ipExtendStatus !== 10 && getApproveStatus(ip.ipPengesahan.ipWorkflow) == '7'") Approved on {{formatDate(getApproveDate(ip.ipPengesahan.ipWorkflow))}}
        v-toolbar-title(v-else-if="ip.ipExtendStatus !== 10 && getApproveStatus(ip.ipExtendWorkflow) == '7'") Approved on {{formatDate(getApproveDate(ip.ipExtendWorkflow))}}
        v-toolbar-title(v-if="getApproveStatus(ip.ipExtendWorkflow) == '8'") Rejected on {{formatDate(getApproveDate(ip.ipExtendWorkflow))}}
        v-toolbar-items
            v-btn(v-if="dialogType == 'approval' && isCurrentApprover()" @click.stop="approvalDialog = true" color="red" depressed title='Approval' class="blink") 
                v-icon(title="Approval") assignment_turned_in
                | &nbsp; Approval
            v-dialog(v-if="dialogType == 'approval' && isCurrentApprover()" v-model="approvalDialog" persistent max-width="500px")
                v-card()
                    v-card-title(class="headline grey lighten-2") Approval Form
                    v-card-text
                        v-layout(wrap)
                            v-flex(xs12)
                                v-radio-group(v-model="approval" row)
                                    v-radio(label="Approve" color="success" value="7")
                                    v-radio(v-if="ip.ipExtendStatus !== 10" label="Reject" color="red" value="8")
                                    v-radio(v-if="ip.ipExtendStatus == 10" label="Need Review" color="yellow darken-4" value="11")
                                    v-radio(v-else label="Need Review" color="yellow darken-4" value="3")
                            v-flex(xs12)
                                v-textarea(
                                    v-model="comment"
                                    filled
                                    label="Comment (Optional)"
                                    value=""
                                )
                    v-card-actions
                        v-spacer
                        v-btn(text @click.native="approvalDialog = false") Close
                        v-btn(:disabled="!approval" text :loading="approvalDialog2" color="blue darken-1" @click="approvalDialog2 = true") Submit
                        v-dialog(
                            v-model="approvalDialog2"
                            hide-overlay
                            persistent
                            width="300")
                            v-card(color="primary" dark)
                            v-card-text Processing. Please wait!
                                v-progress-linear(indeterminate color="white" class="mb-0")
            v-btn(v-if="this.ip.ipExtendStatus == 4 || this.ip.ipExtendStatus == 8" @click="shareIP();" color="red" depressed title="Share" )
                v-icon share
                | &nbsp; Share
                v-dialog(v-model="share" persistent max-width="400px")
                    v-card
                        v-card-title(class="headline grey lighten-3") Share
                        v-flex(class="headline grey lighten-3")
                            v-row(no-gutters align="center" justify="center")
                                ShareNetwork(
                                    v-for="network in networks"
                                    :key="network.key"
                                    class="ma-3 pa-3 green"
                                    :network="network.network"
                                    style="border-radius: 10px; box-shadow: -2px 4px #888888;"
                                    :url="shortenUrl"
                                    :title="sharing.title"
                                    :description="sharing.description"
                                ) 
                                    i(:class="network.icon" style="color:white")
                                    span(class="ma-3" style="color:white") {{ network.name }}
                        v-spacer
                        v-flex(class="text-end headline grey lighten-2")
                            v-btn(color="blue darken-1" text @click.native="share = false") Close
            v-btn(@click="ip.ipExtendStatus == 4 || ip.ipExtendStatus == 8 ? print = true : printIP(ip._id)" color="red" depressed title="Print" )
                v-icon print
                | &nbsp; Print
                v-dialog(v-model="print" persistent max-width="400px")
                    v-card
                        v-card-title(class="headline grey lighten-3") Print Document
                        v-alert(:value='true' color="success")
                            h3(style="text-align: center; font-weight:normal; color: white;") To save the trees, please think to share it rather than print.
                        v-flex(class="headline grey lighten-3")
                            v-row(no-gutters align="center" justify="center")
                                v-btn(@click="printIP(ip._id); print = false;" class="ma-3 pa-3 red darken-2" style="border-radius: 10px; box-shadow: -2px 4px #888888;")
                                    i(class="far fah fa-lg fa fa-print" style="color:white")
                                    span(class="ma-3" style="color:white") Print
                                v-btn(@click="print = false; shareIP();" class="ma-3 pa-3 green" style="border-radius: 10px; box-shadow: -2px 4px #888888;")
                                    i(class="far fah fa-lg fa fa-share-alt" style="color:white")
                                    span(class="ma-3" style="color:white") Share
                        v-spacer
                        v-flex(class="text-end headline grey lighten-2")
                            v-btn(color="blue darken-1" text @click.native="print = false") Close
            v-btn(onClick="javascript:window.close()" color="red" depressed)
                v-icon(title="Close") cancel
                | &nbsp; Close
    v-list(class="print-bg padTop60")
        div(:id="ip._id")
            .page(size="Auto")
                div(class="view-width" style="font-size:10px;")
                    div(v-if="ip.ipExtendStatus == 4" id="background")
                        p(class="fontWatermarkUp" ) {{ip.ipNo}}
                        img(src="../assets/Approve.png" class="imgWatermark")
                        p(class="fontWatermarkDown" ) {{ip.ipNo}}
                    div(v-else-if="ip.ipExtendStatus == 8" id="background")
                        p(class="fontWatermarkUp" ) {{ip.ipNo}}
                        img(src="../assets/reject.png" class="imgWatermark")
                        p(class="fontWatermarkDown" ) {{ip.ipNo}}
                    div(v-else-if="ip.ipExtendStatus == 13" id="background")
                        p(class="fontWatermarkUp" ) {{ip.ipNo}}
                        img(src="../assets/Auto Canceled.png" class="imgWatermark")
                        p(class="fontWatermarkDown" ) {{ip.ipNo}}
                    div(v-else-if="ip.ipExtendStatus == 14" id="background")
                        p(class="fontWatermarkUp" ) {{ip.ipNo}}
                        img(src="../assets/Auto Rejected.png" class="imgWatermark")
                        p(class="fontWatermarkDown" ) {{ip.ipNo}}
                    div(v-else-if="ip.ipExtendStatus == 15" id="background")
                        p(class="fontWatermarkUp" ) {{ip.ipNo}}
                        img(src="../assets/Auto Dropped.png" class="imgWatermark")
                        p(class="fontWatermarkDown" ) {{ip.ipNo}}
                    div(v-else-if="ip.ipExtendStatus == 12" id="background")
                        p(class="fontWatermarkUp" ) {{ip.ipNo}}
                        img(src="../assets/Done.png" class="imgWatermark")
                        p(class="fontWatermarkDown" ) {{ip.ipNo}}
                    table(class="view-width tableInput" style="margin-top:10px;")
                        tbody
                            tr
                                td( class="align-center" width="150" rowspan="3")
                                    img(class="verMiddle" src="../assets/BORNEO-INDOBARA.jpg" width="120px")
                                td(class="align-center") SINARMAS MINING SYSTEM
                                td( class="align-center" width="150" rowspan="3") 
                                    img(class="verMiddle" :src="`${API_URL}/qr/generate/?ipNo=${ip.ipNo}&formCode=${ip.ipForm}&actionFor=extendWaskat`" style="width:80px;margin:2px 0;")
                            tr
                                td(class="align-center") FORMULIR
                            tr
                                td(class="align-center") {{ formName[ip.ipForm] }}
                    
                    table( class="view-width tableInput autoPageBreak" style="margin-top:10px;")
                        thead
                            tr
                                td(class="headerTable" width="150" colspan="7") I. INFORMASI UMUM
                        tbody(style="border: 1px solid black")
                            
                            tr
                                td(width="150" class="headerTable") No Izin Kerja
                                td(colspan="3") {{ ip.ipNo }}
                            tr
                                td(width="150" class="headerTable") Judul Pekerjaan
                                td(colspan="3") {{ ip.ipJudulPekerjaan }}
                            tr
                                td(class="headerTable") Tanggal Pengajuan
                                td(colspan="3") {{ formatDate(ip.ipExtendDate) }}
                            tr
                                td(class="headerTable") Tanggal Pekerjaan (Dari)
                                td {{ formatDate(ip.ipExtendEstimateStart) }}
                                td(width="100" class="headerTable") Sampai
                                td {{ formatDate(ip.ipExtendEstimateEnd) }}
                            tr
                                td(class="headerTable") Jenis Pekerjaan
                                td(colspan="3") {{ip.ipJenisPekerjaan.join(', ')}}
                            tr
                                td(class="headerTable") Zona Kerja
                                td(colspan="3") {{ip.ipZonaKerja.join(', ')}}
                            tr
                                td(width="150" class="headerTable") Lokasi 
                                td {{ locations.join(', ') }}
                                td(width="100" class="headerTable") Sublokasi
                                td {{ip.ipSubLocation}}
                            tr
                                td(colspan="4") Detail Pekerjaan
                            tr
                                td(width="150" class="headerTable") Nama Lengkap
                                td {{ip.ipKaryawan.name}}
                                td(width="100" class="headerTable") Golongan Darah
                                td {{ip.ipKaryawan.bloodType}}
                            tr
                                //- td(width="150" class="headerTable") Nama Panggilan
                                //- td {{ip.ipKaryawan.nickname}}
                                td(width="150" class="headerTable") Tempat,Tgl lahir
                                td {{ip.ipKaryawan.birthPlace}}, {{ formatDate(ip.ipKaryawan.birthDate) }}
                                td(width="100" class="headerTable") Jabatan
                                td {{ip.ipKaryawan.position}}
                            tr
                                td(class="headerTable") No KTP Pekerja
                                td {{ip.ipKaryawan.ktpNumber}}
                                td(width="100" class="headerTable") Departemen
                                td {{ip.ipKaryawan.department}}
                            tr
                                td(width="150" class="headerTable") Perusahaan
                                td(:colspan="ip.ipKaryawan.haveAtasan ? '1' : '3'") {{ip.ipKaryawan.company}}
                                td(v-if="ip.ipKaryawan.haveAtasan" width="100" class="headerTable") No HP Atasan
                                td(v-if="ip.ipKaryawan.haveAtasan") {{ip.ipKaryawan.atasan.phone}}
                            tr(v-if="ip.ipKaryawan.haveAtasan")
                                td(width="150" class="headerTable") Nama Atasan
                                td {{ip.ipKaryawan.atasan.name}}
                                td(width="100" class="headerTable") Email Atasan
                                td {{ip.ipKaryawan.atasan.email}}
                            //- tr
                            //-     td(class="headerTable") No KTP Pekerja
                            //-     td(colspan="3") {{ip.ipKaryawan.ktpNumber}} 
                            tr
                                td(class="headerTable") No HP Pekerja
                                td(colspan="3") {{ip.ipKaryawan.phone}}
                            tr
                                td(class="headerTable") Email Pekerja
                                td(colspan="3") {{ip.ipKaryawan.email}}
                            tr
                                td(class="headerTable") Kontak Darurat Pekerja
                                td(colspan="3") {{ip.ipKaryawan.emergencyPhone}}
                            
                    table( class="view-width tableInput autoPageBreak" style="margin-top:10px;")
                        tbody
                            tr
                                td(class="headerTable") II. DESKRIPSI DETAIL PEKERJAAN (spesifik dan tidak boleh ada tambahan kegiatan diluar cakupan yang tertera dalam izin ini)
                            tr
                                td
                                    div(v-html="ip.ipJobDescription" class="ck-content")
                    
                    table( class="view-width tableInput autoPageBreak" style="margin-top:10px;")
                        tbody
                            tr
                                td(class=" headerTable" width="150" colspan="8") IV. PERSYARATAN KHUSUS UNTUK PENCEGAHAN INSIDEN
                            tr
                                td(width="150" colspan="8") Berikan tanda check pada kolom di bawah Ya (Y) / Tidak (T) / Tidak Perlu (TP)
                            tr
                                td(class="align-center headerTable") Daftar Periksa
                                td(class="align-center headerTable" width="40") Y
                                td(class="align-center headerTable" width="40") T
                                td(class="align-center headerTable" width="40") TP
                            tr
                                td Surat - surat dari dokter 
                                td(class="align-center")
                                    img(v-if="ip.ipUploadedDocsStatus.doctorStatement == daftarPeriksaStatus.ya" class="verMiddle" src="../assets/check.png" width="10")
                                td(class="align-center")
                                    img(v-if="ip.ipUploadedDocsStatus.doctorStatement == daftarPeriksaStatus.tidak" class="verMiddle" src="../assets/check.png" width="10")
                                td(class="align-center")
                                    img(v-if="ip.ipUploadedDocsStatus.doctorStatement == daftarPeriksaStatus.na" class="verMiddle" src="../assets/check.png" width="10")
                                
                            tr
                                td Salinan KTP
                                td(class="align-center")
                                    img(v-if="ip.ipUploadedDocsStatus.ktpCopy == daftarPeriksaStatus.ya" class="verMiddle" src="../assets/check.png" width="10")
                                td(class="align-center")
                                    img(v-if="ip.ipUploadedDocsStatus.ktpCopy == daftarPeriksaStatus.tidak" class="verMiddle" src="../assets/check.png" width="10")
                                td(class="align-center")
                                    img(v-if="ip.ipUploadedDocsStatus.ktpCopy == daftarPeriksaStatus.na" class="verMiddle" src="../assets/check.png" width="10")
                                
                            tr
                                td JSA / AKA yang sudah disosialisasi
                                td(class="align-center")
                                    img(v-if="ip.ipUploadedDocsStatus.jsaAka == daftarPeriksaStatus.ya" class="verMiddle" src="../assets/check.png" width="10")
                                td(class="align-center")
                                    img(v-if="ip.ipUploadedDocsStatus.jsaAka == daftarPeriksaStatus.tidak" class="verMiddle" src="../assets/check.png" width="10")
                                td(class="align-center")
                                    img(v-if="ip.ipUploadedDocsStatus.jsaAka == daftarPeriksaStatus.na" class="verMiddle" src="../assets/check.png" width="10")
                                
                            tr
                                td Induksi Khusus
                                td(class="align-center")
                                    img(v-if="ip.ipUploadedDocsStatus.specialInduction == daftarPeriksaStatus.ya" class="verMiddle" src="../assets/check.png" width="10")
                                td(class="align-center")
                                    img(v-if="ip.ipUploadedDocsStatus.specialInduction == daftarPeriksaStatus.tidak" class="verMiddle" src="../assets/check.png" width="10")
                                td(class="align-center")
                                    img(v-if="ip.ipUploadedDocsStatus.specialInduction == daftarPeriksaStatus.na" class="verMiddle" src="../assets/check.png" width="10")

                            tr
                                td Berkas lain-lain
                                td(class="align-center")
                                    img(v-if="ip.ipUploadedDocsStatus.other == daftarPeriksaStatus.ya" class="verMiddle" src="../assets/check.png" width="10")
                                td(class="align-center")
                                    img(v-if="ip.ipUploadedDocsStatus.other == daftarPeriksaStatus.tidak" class="verMiddle" src="../assets/check.png" width="10")
                                td(class="align-center")
                                    img(v-if="ip.ipUploadedDocsStatus.other == daftarPeriksaStatus.na" class="verMiddle" src="../assets/check.png" width="10")
                                

                    table(style="margin-top:10px;width:3cm;border: 1px solid black;" class="autoPageBreak")
                        tbody(v-if="ip.ipUploadedDocs.docPendukung") 
                            v-btn(tile text @click="download(ip.ipUploadedDocs.docPendukung)" style="font-size:12px;letter-spacing:0px;margin:0px;padding:0;min-width:0;text-transform: none;font-family: 'Arial Narrow';font-weight:normal" height="auto") 
                                tr
                                    td(style="padding-left:1px" ) 
                                        v-icon(small) mdi-attachment
                                    td(style="padding-left:3px;background-color: rgb(204,204,204)") Download Dokumen
                                    td(style="background-color: rgb(204,204,204);padding-right:4px;padding-left:1px")
                                        img(src="../assets/check.png" width="10" )
                        tbody(v-else)
                            tr
                                td(style="padding-left:1px" ) 
                                    v-icon(small) mdi-attachment
                                td(style="padding-left:3px;background-color: rgb(204,204,204)") Download Dokumen
                                td(style="background-color: rgb(204,204,204);padding-right:4px" )
                                    img(src="../assets/close.png" width="10" class="verMiddle")

                    table(class="view-width tableInput autoPageBreak" style="margin-top:10px;")
                        tbody
                            tr
                                td(class="headerTable pl-2" colspan="6") V. PENGESAHAN
                            tr
                                td(class="pl-2" colspan="6") 
                                    b Catatan:
                                    ul
                                        li 
                                            i Pengajuan internal BIB ditandatangani oleh pengawas area kerja & Dept. Head Custodian, kemudian divalidasi oleh OHS Operation masing-masing area.
                                        li 
                                            i Jika pengajuan izin dari mitra kerja maka harus ditandatangani oleh PJO dan penanggung jawab area, serta divalidasi dahulu oleh praktisi safety.
                            tr
                                td(class="headerTable pl-2" rowspan="2" width="7%")
                                td(class="headerTable align-center" width="20%") Nama
                                td(class="headerTable align-center" width="20%") Jabatan
                                td(class="headerTable align-center" width="20%") Tanggal
                                td(class="headerTable align-center" width="20%" colspan="2") Tanda Tangan
                            tr(v-for="(item, index) in ip.ipExtendWorkflow" :key="index")
                                td(
                                    v-if="index === 1 && item.postAs == 'waskat'"
                                    class="headerTable pl-2" width="7%"
                                    :rowspan="ip.ipWaskats.length"
                                ) Pengawas
                                td(
                                    v-else-if="index > 1 && item.postAs == 'waskat'"
                                    style="display: none;"
                                )
                                td(
                                    v-else-if="index > 0"
                                    class="headerTable pl-2" width="7%"
                                ) {{ ['secHead', 'atasan', 'pjo'].includes(item.postAs) ? 'Diketahui Oleh' : 'Disetujui Oleh' }}
                                td
                                    div(class="approved")
                                        br
                                        | {{ item.admin_reject == true ? item.admin_detail.name : item.name }} 
                                td
                                    div(class="approved")
                                        br
                                        | {{ item.admin_reject == true ? 'Admin' : (item.postAs == "atasan" ? 'Atasan' : item.position || item.title) }} {{ (item.title == undefined) ? jabatanDetail(item.postAs, index, ip.ipForm) : '' }}
                                td
                                    div(v-if="item.status == 7" class="approved")
                                        br
                                        | {{approvalTime(item.date)}}
                                        br
                                    div(v-else-if="item.status == 8" class="approved")
                                        br
                                        | {{approvalTime(item.date)}}
                                        br
                                    div(v-else class="emptySign")
                                td
                                    div(v-if="item.status == 7" class="approved")
                                        img(src="../assets/check-64.png" style="width:25px;")
                                    div(v-else-if="item.status == 8" class="approved")
                                        img(src="../assets/close-64.png" style="width:25px;")
                                    div(v-else class="emptySign")
                                td
                                    p(v-if="item.comment || ''" class="align-left top-align comment") {{ item.comment }}
                                    div(v-else class="emptySign")
</template>

<script>
import axios from 'axios';
import * as config from "../config/index.json";
import helper from "../helper/index.js";
import { mapState } from 'vuex';
import printJS from 'print-js';
import { handleGlobalErrorApproval } from '../helper/handleGlobalError.js';
export default {
  name: 'JangkaPendekExtendViewEmail',
  props: {
    dialogType: String,
    ip: Object,
    approvalUser: Object,
    activeStatus: Number,
    actionFor: { type: String, default: null }
  },
  data: () => ({
    daftarPeriksaStatus: {
        ya: 'Ya',
        tidak: 'Tidak',
        na: '',
    },
    formName: config.FormName,
    dialog: false,
    regex: /\//gi,
    approvalDialog: false,
    approvalDialog2: false,
    comment: '',
    approval: null,
    share: false,
    print: false,
    snackbar: false,
    snackbarMessage: ''
  }),
  mounted(){
  },
  computed: {
    ...mapState(['API_URL', "sharing", "networks", "shortenUrl"]),
    locations(){
        let temp = []
        for (const index in this.ip.ipLocation) {
            temp.push(this.ip.ipLocation[index].name)
        }
        return temp
    },
  },
  methods: {
    jabatanDetail: helper.jabatanDetail,
    download(file) {
        this.$downloadFile(file, this.$route.params.token);
    },
    shareIP() {
        this.$store.dispatch("getShortenUrl", {ip: this.ip, 
        approvalUser: this.approvalUser, context: this.share, token: this.getViewToken()}).then(() => {
            this.share = true;
        });
    },
    getViewToken() {
        const splicedPathname = window.location.pathname.split('/');
        return splicedPathname[splicedPathname.length - 1];
    },
    printIP(id){
        printJS({
            printable: id, 
            type: 'html',
            scanStyles: false,
            css: ["/stylesheets/main.css" ,"/stylesheets/approval.css", "/stylesheets/vuetify.min.css", '/stylesheets/view.css', "/stylesheets/ck-content.css"]
        });
    },
    formatDate: helper.formatDateOnly,
    getApproveStatus(wf){
        if(!this.approvalUser) return false;
        let status = 0;
        for(let i=0;i<wf.length;i++){
            if(wf[i].nik == this.approvalUser.nik && !this.isCurrentApprover()){
                status=wf[i].status;
                break;
            }
        }
        return status;
    },
    getApproveDate(wf){
        if(!this.approvalUser) return false;
        let approvedWf = null;
        for(let i=0;i<wf.length;i++){
            if(wf[i].nik == this.approvalUser.nik){
                approvedWf=wf[i];
                break;
            }
        }
        return approvedWf.date;
    },
    isCurrentApprover(){
        if (!this.ip || !this.approvalUser) return false;
        const isOnApproval = Number(this.ip.ipExtendStatus) === 2;
        const isNeedApproval = Number(this.activeStatus) === 9;
        const isAuthenticated = (isOnApproval && isNeedApproval);
        return helper.isApprover(
            isAuthenticated,
            this.ip,
            this.approvalUser,
            'extendWaskat'
        );
    },
    approvalTime(date){
        return new Date(date).toLocaleString('en-GB');
    },
    getNameApproverKTT(item) {
        return helper.getKTTApproverName(item)
    },
    getTitleApprover(item) {
        if ( item.matrix == 'KTT' ) {
            return 'Kepala Teknik Tambang'
        } else {
            return item.title
        }
    }
  },
  watch: {
    approvalDialog2 (val) {
        if (!val) return
        const formData = {
            ipNo: this.ip.ipNo,
            status: JSON.parse(this.approval),
            comment: this.comment,
            approvalUser: this.approvalUser
        }
        const config = {
            method: "post",
            url: `${this.API_URL}/v1/requests/waskat/extend/approve`,
            headers: {"Authorization": `Bearer ${this.$route.params.token}`},
            data: formData
        };
        axios(config).then(res => {
            if (res.status == 200) {
                setTimeout(() => {
                    this.dialog2 = false;
                    this.dialog = false;
                    location.reload();
                },
                1000);
            }
        }).catch(error => {
            handleGlobalErrorApproval(error, {
                setSnackbarMessage: (msg) => { this.snackbarMessage = msg; },
                showSnackbar: (show) => { this.snackbar = show; },
                closeModals: () => { 
                    this.approvalDialog = false; 
                    this.approvalDialog2 = false; 
                },
                disableLoader: () => { 
                    this.$store.state.loader = false;
                },
            });
        });
     
    }
    
  }
};
</script>
<style scoped>
.print-bg {
  background: rgb(204,204,204);
  padding-top: 10px;
}
.print-bg > div{
  text-align:center;
}
.page {
  background: white;
  display: block;
  margin: 5px auto;
  padding: 0.7cm 1cm 0.8cm;
  position: relative;
}
.page[size="A4"] {
  width: 21cm;
  height: 29.7cm;
}
.page[size="Auto"] {
  width: auto;
  margin:0 auto;
  display:inline-block;
  text-align:initial;
}
.view-width {
  width: 19cm;
}
.print-header {
  border-collapse: collapse;
  text-align: right;
}
.padding-x-3 {
  padding:0 3px;
}
.padding-xy-5 {
  padding:2px;
}
.padding-xy-1 {
  padding:1px;
}
.margin-tl-5 {
  margin: 3px 5px 0 5px;
}
.margin-tl-10 {
  margin: 3px 10px 0 10px;
}
.margin-tl-25 {
  margin: 3px 15px 0 25px;
}
.logo-cell {
  padding:8px 5px 0px;
  width:35%;
}
.detail-wrap {
  margin-top: 5px;
}
.border-left-0 {
  border-left: 0;
}
.border-right-0 {
  border-right: 0;
}
.approved {
  text-align: center;
  padding:5px;
}
.ff0000 {
  color: #ff0000;
}
.align-center {
  text-align: center;
}
.align-left {
 align-items: left;
}
.width-20p {
  width:20%;
}
.width-25p {
  width:25%;
}
.height-40px {
  height: 40px;
}
.width-300px {
  width: 250px;
}
.top-align {
  vertical-align:top;
}
.navFixed {
  position: fixed;
  z-index: 9;
}
.padTop60 {
  padding-top:60px;
}
.blink {
	-webkit-animation: blink 2s steps(5, start) infinite;
  animation: blink 2s steps(5, start) infinite;
  color: #dddddd;
}
@-webkit-keyframes blink { to { color: #ffffff; }}
@keyframes blink { to { color: #ffffff; }}
@media print {
    
}
table {
  border-collapse: collapse;
}
.headerTable{
    border: 1px solid black; 
    background-color: #cccccc;
}
.tableInput td{
    border: 1px solid black;
    padding-left: 5px;
}
.verMiddle{
    vertical-align:middle;
}
.comment{
    word-break: break-all;
}
.tableCollapse td{
    border: 1px solid black;
    border-top: 0;
    padding-left: 5px;
}
.emptySign {
    text-align: center;
    padding: 5px;
}
#background {
  position:absolute;
  z-index:0;
  display:block;
  top:150px;
  left:0px;
  text-align: center;
  width: 100%;
}
.imgWatermark {
  width: 650px;
  position:absolute;
  top:0px;
  right:50px;
  opacity: 0.65;
}
.fontWatermarkUp {
  font-size:450%; 
  position:absolute;
  transform: rotate(-30deg);
  opacity: 0.65;  
  right: 200px;
  color: rgb(224,224,224);
}
.fontWatermarkDown {
  font-size:450%; 
  position:absolute;
  transform: rotate(-30deg);
  opacity: 0.65;  
  top: 450px;
  right: 100px;
  color: rgb(224,224,224);
}

.custom__position-for{
  font-size: 8px; 
  font-style: italic; 
  position: absolute; 
  bottom: 0; 
  left: 0;
}
</style>
